<template>
  <div class="user-data">
    <div class="header g-flex-center-start"><span></span><span>新用户</span><span>百分比</span><span>老用户</span><span>百分比</span></div>
    <div class="g-flex-center-start"><span>用户人数</span><span>{{userData.newUserNumber}}</span><span>{{((userData.newUserNumberProportion || 0) * 100).toFixed(2)}}%</span><span>{{userData.oldUserNumber}}</span><span>{{((userData.oldUserNumberProportion || 0 ) * 100).toFixed(2)}}%</span></div>
    <div class="g-flex-center-start"><span>消费金额</span><span>{{userData.newUserSaleAmount}}</span><span>{{((userData.newUserSaleAmountProportion || 0) * 100).toFixed(2)}}%</span><span>{{userData.oldUserSaleAmount}}</span><span>{{((userData.oldUserSaleAmountProportion || 0) * 100).toFixed(2)}}%</span></div>
    <div class="g-flex-center-start"><span>客单价</span><span>{{userData.newUserUnitPricePerCustomer}}</span><span>--</span><span>{{userData.oldUserUnitPricePerCustomer}}</span><span>--</span></div>
  </div>
</template>
<script>
export default {
  props: {
    userData: {
      type: Object
    }
  }
}
</script>
<style lang="less" scoped>
  .user-data{
    margin-top: 20px;
    >div{
      >span{
        width: 20%;
        height: 50px;
        text-align: center;
        line-height: 50px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #222222;
        border:1px solid #F4F4F4;
      }
    }
    .header{
      background: #F8F9FD;
      >span{
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #222222;
      }
    }
  }
</style>